// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"I8-z"};